import { CSSProperties } from "react";

const getColorForCoordinate = (result: string): string => {
  // Simple color scheme: black for hits, red for outs
  if (result === "Hits") return "#000000";
  if (result === "Outs") return "#ef4444";

  // default to black
  return "#000000";
};

const BALL_RADIUS = 0.770833;
const ORIGIN_X_IN_CHART_SCALE = 25;
const ORIGIN_Y_IN_CHART_SCALE = 37;

interface Coordinate {
  xFeet: number;
  yFeet: number;
  result: string;
}

interface PointOfContactProps {
  style?: CSSProperties;
  coordinates?: Coordinate[];
}

export const PointOfContact: React.FC<PointOfContactProps> = ({
  style,
  coordinates,
}) => {
  const legendItems = coordinates
    ? Array.from(
        new Set(coordinates.map(({ result }) => JSON.stringify({ result }))),
      ).map((item) => JSON.parse(item))
    : [];

  return (
    <div style={{ position: "relative", ...style }}>
      <svg
        style={{
          width: "100%",
          height: "100%",
          maxWidth: "1200px",
          maxHeight: "1000px",
        }}
        baseProfile="full"
        height="50"
        version="1.1"
        viewBox="0,0,50,50"
        width="50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="white" height="100%" width="100%" x="0" y="0" />
        <g
          style={{
            stroke: "black",
            strokeWidth: ".1mm",
            strokeLinejoin: "round",
            strokeLinecap: "round",
          }}
        >
          <line x1="25.0" x2="16.5" y1="37.0" y2="28.5" />
          <line x1="16.5" x2="16.5" y1="28.5" y2="20.0" />
          <line x1="16.5" x2="33.5" y1="20.0" y2="20.0" />
          <line x1="33.5" x2="33.5" y1="20.0" y2="28.5" />
          <line x1="33.5" x2="25.0" y1="28.5" y2="37.0" />
        </g>
        <g style={{ fill: "lightgray" }}>
          <rect height="72" width="48" x="-37.5" y="-7.5" />
          <rect height="72" width="48" x="39.5" y="-7.5" />
        </g>
        {coordinates?.map(({ xFeet, yFeet, result }, index) => (
          <circle
            key={index}
            cx={ORIGIN_X_IN_CHART_SCALE + xFeet * 12} // the chart was drawn in inches, so multiplying by 12 to from inches to feet
            cy={ORIGIN_Y_IN_CHART_SCALE - yFeet * 12}
            r={BALL_RADIUS}
            fill={getColorForCoordinate(result)}
          />
        ))}
      </svg>

      {legendItems.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {legendItems.map(({ result }, index) => {
            return (
              <div
                key={index}
                style={{ display: "flex", alignItems: "center" }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: getColorForCoordinate(result),
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                />
                <span style={{ fontSize: "12px" }}>{result}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
